var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVideoIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.6663 5.95423C14.6663 5.55035 14.6663 5.34841 14.5865 5.2549C14.5172 5.17376 14.4132 5.13071 14.3069 5.13908C14.1843 5.14873 14.0415 5.29152 13.7559 5.5771L11.333 7.99998L13.7559 10.4229C14.0415 10.7084 14.1843 10.8512 14.3069 10.8609C14.4132 10.8693 14.5172 10.8262 14.5865 10.7451C14.6663 10.6515 14.6663 10.4496 14.6663 10.0457V5.95423Z",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.33301 6.53331C1.33301 5.41321 1.33301 4.85316 1.55099 4.42533C1.74274 4.04901 2.0487 3.74305 2.42503 3.5513C2.85285 3.33331 3.4129 3.33331 4.53301 3.33331H8.13301C9.25311 3.33331 9.81317 3.33331 10.241 3.5513C10.6173 3.74305 10.9233 4.04901 11.115 4.42533C11.333 4.85316 11.333 5.41321 11.333 6.53331V9.46665C11.333 10.5868 11.333 11.1468 11.115 11.5746C10.9233 11.951 10.6173 12.2569 10.241 12.4487C9.81317 12.6666 9.25311 12.6666 8.13301 12.6666H4.53301C3.4129 12.6666 2.85285 12.6666 2.42503 12.4487C2.0487 12.2569 1.74274 11.951 1.55099 11.5746C1.33301 11.1468 1.33301 10.5868 1.33301 9.46665V6.53331Z",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideoIcon);
export default __webpack_public_path__ + "static/media/videoIcon.ee435d0b718bf50d78bd78badb01d5e8.svg";
export { ForwardRef as ReactComponent };